import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GeneralFinanceService {

  // Declaring a Subject named `viewDataNotification`, which will be used to send and receive notifications 
  // related to viewing data across different parts of the application. It allows components or services 
  // to subscribe and react to changes or events when the Subject is updated.
  viewDataNotification: Subject<any> = new Subject();

  // Declaring another Subject named `AccessSharedAddEvent`, which will be used to communicate the event of 
  // adding a shared account. Components or services can subscribe to this Subject to listen for the event 
  // when a new account is being added, and perform necessary actions based on the event type.
  AccessSharedAddEvent: Subject<any> = new Subject();

  
  sendGeneralItem: ReplaySubject<any> = new ReplaySubject(1);

  sendCompanyID: ReplaySubject<any> = new ReplaySubject(1);


  constructor() { }
}
